<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Add Tag</span>
  <form
    [formGroup]="form"
    (ngSubmit)="submit()"
    class="mt-6 flex flex-col p-4"
  >
    <div class="flex flex-col space-y-2">
      <span class="font-medium">Tag Name</span>
      <input
        type="text"
        formControlName="name"
        class="w-full sm:w-2/3 h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
        placeholder="Masukkan nama tag"
      />
    </div>
    <div class="flex flex-col space-y-2 mt-4">
      <span class="font-medium">Budget</span>
      <input
        type="number"
        formControlName="budget"
        placeholder="Masukkan budget"
        class="w-full sm:w-2/3 h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
      />
    </div>
    <div class="flex flex-col space-y-2 mt-4">
      <span class="font-medium">Description</span>
      <textarea
        type="text"
        formControlName="description"
        class="w-full sm:w-2/3 h-32 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
        placeholder="Masukkan deskripsi"
      ></textarea>
    </div>
    <div class="flex flex-col space-y-2 mt-4">
      <span class="font-medium">Teams</span>
      <mat-select
        multiple
        type="text"
        formControlName="teams"
        class="!w-full sm:!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
        placeholder="Pilih team"
      >
        <ng-container *ngFor="let item of teams">
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
        </ng-container>
      </mat-select>
    </div>
    <div class="flex flex-col space-y-2 mt-4">
      <span class="font-medium">Expense Category</span>
      <mat-select
        multiple
        type="text"
        formControlName="expanse_categories"
        class="!w-full sm:!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
        placeholder="Pilih kategori"
      >
        <ng-container *ngFor="let item of expanseCategories">
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
        </ng-container>
      </mat-select>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mt-8">
      <button
        class="w-full sm:w-80 h-12 rounded-lg bg-[#85E2B1] text-white flex items-center justify-center space-x-2"
      >
        <span>Save</span>
      </button>
      <button
        type="button"
        (click)="cancel()"
        class="w-full sm:w-80 h-12 rounded-lg bg-gray-400 text-white flex items-center justify-center space-x-2"
      >
        <span>Cancel</span>
      </button>
    </div>
  </form>
</section>
